import React from "react";

import { Box, Column, Columns, Stack } from "@origin-digital/ods-core";

import {
  IIRecommendationResponse,
  IISystemSizeMinMaxResponse,
} from "@/contract/generated/electrify-v1";

import {
  AlertPanel,
  EntireCost,
  Generation,
  Property,
  Summary,
} from "./components";
import { solarOutlook as content } from "./content.json";
import { BillVision } from "../SharedComponents";

type SingleSystemProps = {
  solarOutlook: IIRecommendationResponse;
  recommendationSystem: IISystemSizeMinMaxResponse;
  showAlert?: boolean;
};

export const SingleSystem = ({
  solarOutlook,
  recommendationSystem,
  showAlert = false,
}: SingleSystemProps) => {
  const { size = 0 } = recommendationSystem;

  return (
    <Stack space={["large", "xlarge"]} data-id={content.testId.singleSystem}>
      <Box
        paddingTop={
          showAlert ? { xs: "medium", sm: "xlarge", lg: "xxlarge" } : "none"
        }
        paddingX={{ xs: "medium", sm: "xlarge", lg: "xxlarge" }}
      >
        <AlertPanel showAlert={showAlert} size={size} />
        <Columns collapseBelow="lg" space="xlarge">
          <Column width="1/3">
            <Property
              solarOutlook={solarOutlook}
              recommendationSystem={recommendationSystem}
            />
          </Column>
          <Column>
            <Summary recommendationSystem={recommendationSystem} />
          </Column>
        </Columns>
      </Box>
      <Box
        display="flex"
        flexDirection={{ xs: "column", lg: "row" }}
        marginX={{ xs: "medium", sm: "xlarge", lg: "xlarge" }}
        marginTop="medium"
      >
        <EntireCost recommendationSystem={recommendationSystem} />
        <BillVision recommendationSystem={recommendationSystem} />
        <Generation
          fitPrice={solarOutlook.fitPrice ?? 0}
          recommendationSystem={recommendationSystem}
        />
      </Box>
    </Stack>
  );
};
